import Chip, { chipType } from '../chip/chip'

import './historyCard.scss'

type HistoryCardPorps = {
  fromTo: string
  position: string
  url: string
  text: string
  devTypes: Array<chipType>
}

function HistoryCard(props: Readonly<HistoryCardPorps>) {
  return (
    <div className='comp-card'>
      <div className='card-time'>{props.fromTo}</div>
      <div className='card-info'>
        <div className='info-title'>
          <div>{props.position} |</div>
          <div style={{ marginLeft: 6 }}>{props.url}</div>
        </div>
        <div className='info-text'>{props.text}</div>
        <div className='info-dev'>
          {props.devTypes.map((type) => <Chip key={type} type={type} />)}            
        </div>
      </div>
      <div className='card-bottom'>
        <div className='bottom-lab'/>
      </div>
    </div>
  )
}

export default HistoryCard
